import axios from "axios"
import React, { Component } from "react"
import { connect } from "react-redux"
import { Redirect } from "react-router-dom"
import moment from "moment"
// import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom"

const port = process.env.PORT || 3000
//process.env.NODE_ENV = process.env.NODE_ENV || 'development';
//const baseUrl = process.env.BASE_URL || 'http://localhost:3000'

//process.env.NODE_ENV = process.env.NODE_ENV || 'development';
//const winLocUrl = window.location.host;
//const protocol = window.location.protocol;
let baseUrl = "http://localhost:3000"
if (process.env.NODE_ENV === "production") {
  baseUrl = window.location.origin
}

//console.log('UploadPage WinLoc/Port', `${winLocUrl}:${port}`)
//console.log('baseUrl: ', baseUrl)

import { startImportExpense } from "../actions/imports"
import { startSetExpenses, startAddExpense } from "../actions/expenses"
import { startAddLabel, startImportLabels } from "../actions/labels"
import { labels } from "../selectors/labels"

//import { storageRef, f as fb, database } from "../firebase/firestore.js";
//import database, { firebase } from '../firebase/firebase';
import { storageRef, f as fb, database } from "../firebase/firestore2.js"
import { now } from "moment"
import { firebase } from "../firebase/firebase"
//import { Router } from 'express';

//const storageRef = firebase.storage()
//allowUploads: firebase.ref(`users/${user.uid}/permissions`)
//this.props.user.uid

class UploadPage extends React.Component {
  constructor(props) {
    super(props)
    //console.log(this.props); // undefined
    console.log(props) // defined

    // storageRef.once(`users/${this.props.user.uid}/permissions`, (data) => {
    // do some stuff once
    //   console.log(data)
    // })
  }

  state = {
    // Initially, no file is selected
    selectedFile: null,
    loaded: 0,
    uid: this.props.user.uid ? this.props.user.uid : "user05202020",
    togglePosted: false,
    idToken: this.props.user.idToken ? this.props.user.idToken : "",
    jsonData: [],
    labels: [],
    account: "",
  }

  // firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function(idToken) {
  //     // Send token to your backend via HTTPS
  //     // ...
  //   }).catch(function(error) {
  //     // Handle error
  //   });

  // On file select (from the pop up)
  onFileChange = (event) => {
    const files = event.target.files
    // Update the state
    //selectedFile: event.target.files[0] });
    this.setState({
      selectedFile: files,
      togglePosted: false,
    })
  }

  submitForm = (url, contentType, data, setResponse) => {
    axios({
      url: `${url}/upload`,
      method: "POST",
      data: data,
      headers: {
        "Content-Type": contentType,
      },
    })
      .then((response) => {
        setResponse(response.data)
      })
      .catch((error) => {
        setResponse("error")
      })
  }

  // request.onerror = function handleError(response) {
  //     // Real errors are hidden from us by the browser
  //     // onerror should only fire if it's a network error
  //     reject(createError('Network Error', config, null, request, response));
  //     // Clean up request
  //     request = null;
  //   };`

  // onGetFileUpload = () => {

  // }

  //var csv is the CSV file with headers
  csvToJSONResults = []

  // csvWrapper = (csv)=>{
  //     return new Promise((resolve,reject)=>{

  //     })
  // }

  csvWrapper = (csv, headerLine) => {
    return new Promise((resolve, reject) => {
      var res = this.csvToJSON(csv, headerLine)
      if (res) {
        resolve(res)
      } else reject(res)
    })
  }

  scrubJSONData = (data) => {
    for (let index = 0; index < data.length; index++) {
      if (data[index].Type == "") {
        data[index].Type = "Fee"
      }
    }
    return data
  }

  validateWrapper = (file) => {
    return new Promise((resolve, reject) => {
      var res = this.validateFile(file)
      if (res !== -1) {
        resolve(res)
      } else reject(res)
    })
  }

  validateFile = (csv) => {
    const baCC = "CardHolder Name,Account/Card Number - last 4 digits,Posting Date"
    const baChecking = "Date,Description,Amount"
    const chaseCC_Old = "Transaction Date,Post Date,Description"
    const chaseCC = "Card,Transaction Date,Post Date,Description"
    let headerLine = -1
    const csvLines = csv.split("\n")

    for (let index = 0; index < csvLines.length; index++) {
      //const element = array[index];
      //console.log("validateFile Line: ", csvLines[index])

      if (csvLines[index].search(baCC) === 0) {
        this.setState({
          account: "BA-Credit",
        })
        headerLine = index
        break
      }
      if (csvLines[index].search(baChecking) === 0) {
        this.setState({
          account: "BA-Checking",
        })
        headerLine = index
        break
      }
      if (csvLines[index].search(chaseCC) === 0 || csvLines[index].search(chaseCC_Old) === 0) {
        //console.log("FileName: ", fileName)
        let inFileName = this.state.selectedFile[0].name
        console.log("FileName: ", this.state.selectedFile[0].name)

        if (inFileName.search("Chase0515") === 0 || inFileName.search("Chase8287") === 0) {
          this.setState({
            account: "Credit-0515",
          })
        }
        else {
          this.setState({
            account: "Chase-Credit",
          })
        }

        headerLine = index
        break
      }
    }

    return headerLine
  }

  csvToJSON = (csv, headerLine) => {
    //var headerLine = headerLine(csv)
    var lines = csv.split("\n")
    var result = []
    var headers = lines[headerLine].split(",")
    var quotedValue = ""
    var newLine = ""
    var quotesOn = false
    var newLines = []
    newLines.push(lines[headerLine])
    headerLine++
    for (var i = headerLine; i < lines.length; i++) {
      for (let index = 0; index < lines[i].length; index++) {
        if ((!quotesOn && lines[i].charAt(index) === '"') || (quotesOn && lines[i].charAt(index) === '"')) {
          quotesOn = !quotesOn
        }
        if (quotesOn) {
          // console.log("line chars: ", lines[i].charAt(index))
          if (lines[i].charAt(index) !== ",") {
            newLine = newLine + lines[i].charAt(index)
          }
        } else {
          // console.log("line chars: ", lines[i].charAt(index))
          newLine = newLine + lines[i].charAt(index)
        }

        //const element = array[index];
      }

      console.log("newLine: ", newLine)

      newLines.push(newLine)
      newLine = ""
    }

    lines = newLines

    for (var i = 1; i < lines.length; i++) {
      var obj = {}
      var currentline = lines[i].split(",")

      for (var j = 0; j < headers.length; j++) {
        // console.log('currentLine[j]: ', currentline[j])
        obj[headers[j]] = currentline[j]
      }

      result.push(obj)
    }

    //return result; //JavaScript object
    //console.log(JSON.stringify(result))
    return JSON.stringify(result) //JSON
  }

  // readUploadBuffer = (file, csvFunc) => {
  //     var reader = new FileReader();

  //     reader.onload = (e) => {
  //         var arrayBuffer = reader.result;
  //         var charBuffer = []
  //         console.log(arrayBuffer)
  //         console.log(typeof arrayBuffer)

  //         var n = arrayBuffer.indexOf("\n");
  //         console.log('Joe IndexOf: ', n)

  //         const mycsvWrapper = this.csvWrapper(arrayBuffer)
  //         mycsvWrapper.then((data) => {
  //             console.log("wrapper data: ", data)
  //             this.setState({
  //                 jsonData: data
  //             })
  //         }).catch((e) => {
  //             console.log("error: ", e)
  //         })

  //     }

  //     reader.readAsText(file)

  // }

  readUploadBuffer = (file, csvFunc) => {
    return new Promise((resolve, reject) => {
      var reader = new FileReader()

      reader.onload = (e) => {
        var arrayBuffer = reader.result
        var charBuffer = []
        //console.log(arrayBuffer)
        //console.log(typeof arrayBuffer)
        //console.log(arrayBuffer.find)

        var n = arrayBuffer.indexOf("\n")
        //console.log('Joe IndexOf: ', n)

        // var jsonData = csvFunc(arrayBuffer)
        // console.log("jsonFile: ", jsonData)
        // this.setState({
        //     jsonData: jsonData
        // })

        //const validateUploadWrapper = this.validateWrapper(arrayBuffer)
        //console.log("validate Header Line: ", validateUploadWrapper)
        this.validateWrapper(arrayBuffer)
          .then((res) => {
            console.log("validate Header Line: ", res)

            //const mycsvWrapper = this.csvWrapper(arrayBuffer,res)

            this.csvWrapper(arrayBuffer, res)
              .then((data) => {
                //console.log("wrapper data: ", data)
                this.setState(
                  {
                    jsonData: data,
                  },
                  () => {
                    //console.log("mycsvWrapper state.jsonData: ", this.state.jsonData)
                  }
                )
              })
              .catch((e) => {
                //console.log("error: ", e)
              })
          })
          .catch((e) => {
            console.log("Invalid File")
            alert("Invalid File")
          })
      }

      //reader.readAsArrayBuffer(file);
      reader.readAsText(file)
      reader.onloadend = () => {
        resolve(reader.readyState)
      }
    })
  }

  // readUploadBuffer = (file, csvFunc) => {
  //     var reader = new FileReader();

  //     reader.onload = (e) => {
  //         var arrayBuffer = reader.result;
  //         var charBuffer = []
  //         console.log(arrayBuffer)
  //         console.log(typeof arrayBuffer)
  //         //console.log(arrayBuffer.find)

  //         var n = arrayBuffer.indexOf("\n");
  //         console.log('Joe IndexOf: ', n)

  //         // var jsonData = csvFunc(arrayBuffer)
  //         // console.log("jsonFile: ", jsonData)
  //         // this.setState({
  //         //     jsonData: jsonData
  //         // })

  //         const mycsvWrapper = this.csvWrapper(arrayBuffer)
  //         mycsvWrapper.then((data) => {
  //             console.log("wrapper data: ", data)
  //             this.setState({
  //                 jsonData: data
  //             })
  //         }).catch((e) => {
  //             console.log("error: ", e)
  //         })

  //     }

  //     //reader.readAsArrayBuffer(file);
  //     reader.readAsText(file)

  //     // reader.readUploadBuffer

  // }

  ImportExpenses = () => {
    const { description = "", label = "", note = "", amount = 0, createdAt = 0 } = expenseData
    const expense = { description, label, note, amount, createdAt }

    this.props.startAddExpense(expenseData)
  }

  stripQuotes = (str, offset) => {
    let workAmount = str
    //console.log("Amount: ", item.Amount)
    //console.log("item.Amount.includes(\")", item.Amount.includes("\""))
    if (str.includes('"')) {
      workAmount = workAmount.substr(1, workAmount.length - offset)
    }
    return workAmount
  }

  BulkSubmit = (jsonData) => {
    // CardHolder Name,Account/Card Number - last 4 digits,
    // Posting Date,
    // Trans. Date,
    // Reference ID,
    // Description,
    // Amount,
    // MCC,
    // Merchant Category,
    // Transaction Type,
    // Expense Category

    // const {
    //     description = '',
    //     label = '',
    //     note = '',
    //     amount = 0,
    //     createdAt = 0
    // } = expensesData;

    // const expense = { description, label, note, amount, createdAt };

    // this.props.startAddExpense(expense);
    let labelsPushed = []
    let labels = []
    jsonData.map((item) => {
      let transType = ""
      let debit = true
      //console.log('jsonData.map item: ', item)

      if (item["Transaction Type"] == "D") {
        transType = "Credit"
      } else if (item["Transaction Type"] == "C") {
        transType = "Credit"
        //console.log('item[Transaction Type] == C', transType)
        debit = false
      } else if (item["Type"] == "Sale") {
        transType = "Credit"
      } else if (item["Type"] == "Payment") {
        transType = "Credit"
        debit = false
      } else if (item["Type"] == "Return") {
        transType = "Credit"
        debit = false
      } else if (item["Type"] == "Fee") {
        console.log("Found Type Fee")
        transType = "Credit"
        //debit = false
      } else if (transType !== "Credit" && item["Amount"]) {
        transType = "Bank"
        //console.log('transType = bank')
      } else {
        transType = "Credit"
      }

      if (transType) {
        let newExpense = {}

        if (transType === "Credit") {
          let category = item["Merchant Category"] ? item["Merchant Category"].split(" ")[0] : item["Category"] ? item["Category"].split(" ")[0] : ""
          category = !category ? (item["Type"] ? item["Type"] : category) : category
          //console.log('category: ', category)
          //console.log('category len: ', category.length)
          category = category.length > 2 ? this.stripQuotes(category, 1) : "none"
          console.log("xcategory: ", category)
          console.log("xcategory len: ", category.length)
          let note = category ? category : "none"
          category = this.state.account
          //console.log("category: ", category)
          //console.log("category len: ", category.length)
          //category = category.length > 1 ? category : "none"

          let currentDate = new Date()

          let workAmount = this.stripQuotes(item.Amount, 2)

          //let amount = parseFloat(item.Amount).toFixed(2)
          let amount = parseFloat(workAmount).toFixed(2)

          amount = amount ? parseInt(amount * 100) : 0
          amount = amount > 0 ? (debit ? amount * -1 : amount) : debit ? amount : amount * -1
          newExpense = {
            amount: amount,
            createdAt: item["Posting Date"] ? Date.parse(item["Posting Date"]) : item["Post Date"] ? Date.parse(item["Post Date"]) : 0,
            description: this.stripQuotes(item.Description, 2),
            label: category,
            note: item["Reference ID"] ? ` ${item["Reference ID"]} Card: ${item["Account/Card Number - last 4 digits"]} / ${note}` : `Memo: ${note}`,
            importDate: currentDate.getTime(),
            transType: transType,
          }
        } else if (transType === "Bank") {
          //   Date,Description,Amount,Running Bal.
          //   01/01/2019,Beginning balance as of 01/01/2019,,"4320.76"
          let currentDate = new Date()
          let workAmount = this.stripQuotes(item.Amount, 2)
          let amount = parseFloat(workAmount).toFixed(2)
          amount = amount ? parseInt(amount * 100) : 0
          amount = amount
          let category = amount > 0 ? "Deposit" : "Withdrawal"
          let note = category
          category = this.state.account
          newExpense = {
            amount: amount,
            createdAt: item["Date"] ? Date.parse(item["Date"]) : 0,
            description: this.stripQuotes(item.Description, 2),
            label: category,
            note: `Account: ${transType} / ${note}`,
            importDate: currentDate.getTime(),
            transType: transType,
          }
        }

        try {
          //console.log("Data saved successfully.");
          //console.log("newExpense Added: ", newExpense)
          const { description = "", label = "", note = "", amount = 0, createdAt = 0 } = newExpense

          const expense = { description, label, note, amount, createdAt }

          this.props.startAddExpense(expense)

          labels.push(expense.label)

          let labelFound = false

          if (!labelFound) {
            //console.log("Label not Found, Add new Label Here")

            let newLabel = {
              alias: "",
              label: expense.label.toLowerCase(),
              note: "",
              type: "",
            }
            //console.log("labelsPushed[]: ", labelsPushed)

            if (!labelsPushed || labelsPushed.indexOf(newLabel.label) === -1) {
              labelsPushed.push(newLabel.label)

              // if (error) {
              //     console.log("Label Data could not be saved." + error);
              // } else {
              //     console.log("Label Data saved successfully.");

              // }
            }
          }
        } catch (error) {
          console.log("Expense Push Error: ", error)
        }
      } // END IF "D" TRANSACTIONS
    })
    //console.log('newLabelsPushed: ', labelsPushed)
    this.setState(
      () => {
        labels: labelsPushed
      },
      () => {
        this.props.startImportLabels(labelsPushed)
        // props.labelList.map((label) => {
        //     console.log("selectLabel: ", label)
        // })
      }
    )
    //this.props.history.push('/');
  }

  UpdateMetaData = () => {
    const data = {
      id: "222",
      account: "business",
      accountId: "555",
      type: "csv",
      url: downloadURL,
      source: "ba",
      processing: false,
      processed: false,
    }

    const user = {
      id: "123",
      fname: "Joe",
      lname: "Smith",
      email: "joe@gmail.com",
      bucketUrl: downloadURL,
      data: [],
    }

    // const file = this.state.selectedFile[0]
    // const uid = this.props.user.uid
    // const authUID = this.props.user.authUID
    // const contentType = "txt/csv"

    const uploadMetaData = {
      name: file.name,
      type: file.type,
      lastModifiedDate: file.LastModified ? file.LastModified : "",
      bucketUrl: downloadURL,
      bucket: bucket,
      source: "ba",
      uid: uid,
      authUID: authUID,
      processing: false,
      processed: false,
      uploadDate: Date.now(),
    }
    //Date.now()
    //console.log("uploadMetaData: ", uploadMetaData)

    user.data.push(data)
    //console.log("user.data: ", user.data)
    this.props.startImportExpense(uploadMetaData)
  }

  // On file upload (click the upload button)
  onFileUpload = () => {
    const file = this.state.selectedFile[0]
    const fileName = this.state.selectedFile[0].name
    const uid = this.props.user.uid
    const authUID = this.props.user.authUID
    const lmodDate = this.state.selectedFile[0].lastModifiedDate ? this.state.selectedFile[0].lastModifiedDate.toDateString() : "undefined"
    let uploadMetaData = {}

    // var fileData = {}
    // var userData = {}

    const fileData = {
      account: "",
      accountId: "",
      type: "csv",
      url: "",
      source: "ba",
      processing: false,
      processed: false,
    }

    const userData = {
      fname: "",
      lname: "",
      email: "",
      bucketUrl: "",
      data: [],
    }

    userData.data.push(fileData)

    // Create an object of formData
    const formData = new FormData()
    const uidB64 = Buffer.from(this.state.uid, "binary").toString("base64")

    // Update the formData object
    formData.append("file", this.state.selectedFile[0], this.state.selectedFile[0].name)

    // Details of the uploaded file
    console.log(this.state.selectedFile)
    const obj = this.state.selectedFile[0]
    //this.readUploadBuffer(this.state.selectedFile[0], this.csvToJSON)
    this.readUploadBuffer(this.state.selectedFile[0], this.csvToJSON)
      .then(() => {
        console.log("state.jsonData after readUploadBuffer(): ", this.state.jsonData.length)
        formData.append("json", this.state.jsonData)
      })
      .then(() => {
        console.log("readUploadBuffer promise")
        //this.submitForm("http://localhost:3000", "multipart/form-data", formData, (msg) => console.log(msg));

        // ba format
        // CardHolder Name,Account/Card Number - last 4 digits,
        // Posting Date,
        // Trans. Date,
        // Reference ID,
        // Description,
        // Amount,
        // MCC,
        // Merchant Category,
        // Transaction Type,
        // Expense Category
        console.log("Before JSON Parse: ", this.state.jsonData)
        const parsedJsonData = JSON.parse(this.state.jsonData)
        const scrubbedJsonData = this.scrubJSONData(parsedJsonData)

        console.log("Scrubbed JSON Data: ", scrubbedJsonData)
        console.log("all json data: ", parsedJsonData)
        console.log("json Desc: ", parsedJsonData[0]["Description"])
        console.log("json Category: ", this.state.jsonData[0]["Merchant Category"])
        console.log("json type: ", this.state.jsonData[0]["Type"])

        const expenseTest = {
          description: parsedJsonData[0]["Description"] ? parsedJsonData[0]["Description"] : "test desc",
          label: parsedJsonData[0]["Merchant Category"] ? parsedJsonData[0]["Merchant Category"] : "test label",
          note: "test note",
          amount: 0,
          createdAt: 0,
        }

        //this.BulkSubmit(parsedJsonData)
        this.BulkSubmit(scrubbedJsonData)

        // firebase.auth().currentUser.getIdToken().then(function (idToken) {
        //     // Send token to your backend via HTTPS
        //     // ...

        //     const axiosOptions = {
        //         headers: {
        //             'Content-Type': "multipart/form-data",
        //             'Authorization': idToken

        //         }

        //     };

        //     // Request made to the backend api
        //     // Send formData object
        //     console.log("Calling axios: ")

        //     axios.post(`${baseUrl}/upload`, formData, axiosOptions)
        //         .then(res => { // then print response status
        //             console.log("Show Upload Successful!")

        //         }).then(() => {

        //             console.log("Upload Successful!")

        //         })
        //         .catch(err => { // then print response status
        //             console.error('upload failed: ', err)
        //         })

        // }).catch(function (error) {
        //     // Handle error
        // });
      })
      .catch((e) => {
        console.log("Upload Error")
      })

    console.log("jsonData after csvJson()", this.state.jsonData)
    // Update the formData object

    for (const prop in obj) {
      if (prop === "name" && typeof obj[prop] === "string" && obj[prop].match(/.csv/gi)) {
        //console.log(`obj.${prop} = ${obj[prop]}`);
      }
    }

    //console.log('userData: ', userData)
    // this.props.startImportExpense(userData);

    //console.log('uploadMetaData: ', uploadMetaData)
    //this.props.startImportExpense(uploadMetaData);

    setTimeout(() => {
      this.setState({
        togglePosted: true,
      })
      this.props.history.push("/")
    }, 1500)

    // this.props.history.push('/');

    //this.onRedirect()

    // removed due errors redirect to home
    //this.UploadToFirestore()
  }

  // onRedirect = () => {
  //     let redirectPath = '/';
  //     let history = useHistory();
  //     history.push(redirectPath)
  // }

  onRedirect = () => {
    //this.props.history.push('/')
    this.props.startSetExpenses()

    this.props.history.push("/")
  }
  // onRedirect = () => {
  //     //this.props.history.push('/')
  //     this.props.startSetExpenses()
  //     history.push('/dashboard')
  //     this.props.history.push('/')
  // }

  UploadToFirestore = () => {
    //console.log("UploadToFirestore: ", this.state.selectedFile[0])
    const file = this.state.selectedFile[0]
    const uid = this.props.user.uid
    const authUID = this.props.user.authUID
    const contentType = "txt/csv"
    // Create the file metadata
    const metadata = {
      contentType: contentType,
    }
    //gs://react-mead-expense-fs.appspot.com/data/user/json/ba_cc_test.csv
    try {
      // Upload file and metadata to the object 'images/mountains.jpg'
      // const uploadTask = storageRef
      //     .child("data/user/json/" + file.name)
      //     .put(file, metadata);

      const uploadTask = storageRef.child(`users/${uid}/imports/${file.name}`).put(file, metadata)

      let bucket = ""
      uploadTask.then(function (docRef) {
        //console.log("Document written: ", docRef.metadata);
        bucket = docRef.metadata.bucket
      })

      uploadTask.on(
        "state_changed",
        function (snapshot) {
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          //console.log("progress: ", progress)

          // switch (snapshot.state) {
          //     case fb.storage.TaskState.PAUSED:
          //         console.log('Upload is paused');
          //         break;
          //     case fb.storage.TaskState.RUNNING:
          //         console.log('Upload is running');
          //         break;
          // }
        },
        (error) => {
          console.log(error)
        },
        () => {
          // get the uploaded image url back
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            // You get your url from here
            //console.log('File available at', downloadURL);

            const data = {
              id: "222",
              account: "business",
              accountId: "555",
              type: "csv",
              url: downloadURL,
              source: "ba",
              processing: false,
              processed: false,
            }

            const user = {
              id: "123",
              fname: "Joe",
              lname: "Smith",
              email: "joe@gmail.com",
              bucketUrl: downloadURL,
              data: [],
            }

            // const file = this.state.selectedFile[0]
            // const uid = this.props.user.uid
            // const authUID = this.props.user.authUID
            // const contentType = "txt/csv"

            const uploadMetaData = {
              name: file.name,
              type: file.type,
              lastModifiedDate: file.LastModified ? file.LastModified : "",
              bucketUrl: downloadURL,
              bucket: bucket,
              source: "ba",
              uid: uid,
              authUID: authUID,
              processing: false,
              processed: false,
              uploadDate: Date.now(),
            }
            //Date.now()
            //console.log("uploadMetaData: ", uploadMetaData)

            user.data.push(data)
            //console.log("user.data: ", user.data)
            this.props.startImportExpense(uploadMetaData)

            database
              .collection("users")
              .add(user)
              .then((docRef) => {
                //console.log('User Added: ', docRef.id);
              })
              .catch((e) => {
                //console.log("add user failed: ", e)
              })
          })
        }
      )

      // .onSnapshot(function (doc) {
      //     console.log("Current data: ", doc.data());
      // });

      // var docRef = db.collection("cities").doc("SF");

      // docRef.get().then(function(doc) {
      //     if (doc.exists) {
      //         console.log("Document data:", doc.data());
      //     } else {
      //         // doc.data() will be undefined in this case
      //         console.log("No such document!");
      //     }
      // }).catch(function(error) {
      //     console.log("Error getting document:", error);
      // });

      //<Link className="button" to="/">Review Expenses</Link>

      //this.uploadTask()
    } catch (error) {
      console.log("firestore Upload Error: ", error)
    }
  }

  //return <Redirect to='/' />
  redirectStatus = () => {
    if (this.state.togglePosted) {
      return (
        <div>
          <p>Status: File Uploaded</p>

          <p>
            <button className="button" onClick={this.onRedirect}>
              Review Expenses
            </button>
          </p>
        </div>
      )
    } else {
      return (
        <div>
          <p>Status: File Ready To Upload</p>
        </div>
      )
    }
  }
  // File content to be displayed after
  // file upload is complete
  fileData = () => {
    if (this.state.selectedFile) {
      return (
        <div>
          <h2>File Details:</h2>
          <p>File Name: {this.state.selectedFile[0].name}</p>
          <p>File Type: {this.state.selectedFile[0].type}</p>
          <p>Last Modified: {this.state.selectedFile[0].lastModifiedDate ? this.state.selectedFile[0].lastModifiedDate.toDateString() : ""}</p>
        </div>
      )
    } else {
      return (
        <div>
          <br />
          <h4>Choose file to upload and then click Upload</h4>
        </div>
      )
    }
  }

  render() {
    return (
      <div className="upload-container">
        <h1>Upload Expenses</h1>
        <div className="input-group">
          <div className="input-group__item">
            <input className="text-input" type="file" onChange={this.onFileChange} />
            &nbsp;&nbsp;
            <button className="button" onClick={this.onFileUpload}>
              Upload
            </button>
            &nbsp;
          </div>
        </div>
        Last Upload: {this.props.metadata ? this.props.metadata.name : "None"}
        {this.fileData()}
        {this.redirectStatus()}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.auth,
  userRole: state.accounts[0].role ? state.accounts[0].role : "user",
  metadata: state.imports.length > 0 ? { ...state.imports[state.imports.length - 1] } : undefined,
})

const mapDispatchToProps = (dispatch) => ({
  startImportExpense: (metadata) => dispatch(startImportExpense(metadata)),
  startSetExpenses: () => dispatch(startSetExpenses()),
  startAddExpense: (expense) => dispatch(startAddExpense(expense)),
  startAddLabel: (labels) => dispatch(startAddLabel(labels)),
  startImportLabels: (labels) => dispatch(startImportLabels(labels)),
})

export default connect(mapStateToProps, mapDispatchToProps)(UploadPage)



// WEBPACK FOOTER //
// ./src/components/UploadPage.js